import type { EtsyPendingOrder } from '@/services/etsyService';

type EtsyPreviewItem = Pick<EtsyPendingOrder['items'][number], 'previewUrl' | 'fullSizePreviewUrl'>;

export const getPreferredEtsyItemPreviewUrl = (item: EtsyPreviewItem): string | null =>
  item.fullSizePreviewUrl ?? item.previewUrl ?? null;

export const getPreferredEtsyOrderPreviewUrl = (order: Pick<EtsyPendingOrder, 'items'>): string | null => {
  for (const item of order.items) {
    const previewUrl = getPreferredEtsyItemPreviewUrl(item);
    if (previewUrl) {
      return previewUrl;
    }
  }

  return null;
};
